/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Testimonial_Features_LaurenInputs */

const en_testimonial_features_lauren = /** @type {(inputs: Testimonial_Features_LaurenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I always have stacks of papers I want to get through, and it's been so nice to finally find an app that allows me to listen to them on the go with a naturalistic voice. Would recommend!`)
};

const es_testimonial_features_lauren = /** @type {(inputs: Testimonial_Features_LaurenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Siempre tengo pilas de artículos que quiero revisar, y ha sido genial encontrar por fin una app que me permite escucharlos mientras camino con una voz naturalista. ¡La recomendaría!`)
};

/**
* | output |
* | --- |
* | "I always have stacks of papers I want to get through, and it's been so nice to finally find an app that allows me to listen to them on the go with a naturali..." |
*
* @param {Testimonial_Features_LaurenInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const testimonial_features_lauren = /** @type {((inputs?: Testimonial_Features_LaurenInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Testimonial_Features_LaurenInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_testimonial_features_lauren(inputs)
	return en_testimonial_features_lauren(inputs)
});